module.exports = __webpack_public_path__ + "static/2front-outsource-1-845f265a12d68e93ec8ad159caac83ed.png";